import Indicator from './indicator'
const RISE = '#D4332F'
const FALL = '#258D01'

const lineColor = ['#D330FF', '#994300', '#39afe6']

function createLines(arr) {
  return arr.map(({name, color, data}) => {
    return {
      name,
      type: 'line',
      symbol: "none",
      data,
      lineStyle: {
        normal: {
          color,
          width: 1
        }
      }
    }
  })
}

function createMACD (data) {
  const res = Indicator.MACD(12, 26, 9, data, 1)
  let rawData = [
    {name: 'MACD', color: '#666', data: res.macd},
    {name: 'DIF', color: '#da6ee8', data: res.dif},
    {name: 'DEA', color: '#39afe6', data: res.dea}
  ]
  let series = [
    {
      name: 'MACD',
      type: 'bar',
      data: res.macd,
      barWidth: '40%',
      itemStyle: {
        normal: {
          color: function (params) {
            return params.data >= 0 ? RISE : FALL
          }
        }
      }
    }
  ].concat(createLines(rawData.slice(1)))
  return {
    series,
    rawData
  }
}

const createKDJ = function(data) {
  const res = Indicator.KDJ(data)
  let rawData = [
    {name: 'K', color: lineColor[0], data: res.k},
    {name: 'D', color: lineColor[1], data: res.d},
    {name: 'J', color: lineColor[2], data: res.j}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}

const createRSI = function(data) {
  const res = Indicator.RSI(data)
  let rawData = [
    {name: 'RSI6', color: lineColor[0], data: res.rsi6},
    {name: 'RSI12', color: lineColor[1], data: res.rsi12},
    {name: 'RSI24', color: lineColor[2], data: res.rsi24}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}

const createBOLL = function(data) {
  const res = Indicator.BOLL(data)
  let rawData = [
    {name: 'UPPER', color: lineColor[0], data: res.upper},
    {name: 'MID', color: lineColor[1], data: res.mid},
    {name: 'LOWER', color: lineColor[2], data: res.lower}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}


const createOBV = function(data) {
  const res = Indicator.OBV(data)
  let rawData = [
    {name: 'OBV', color: lineColor[0], data: res}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}

const createBIAS = function(data) {
  const res = Indicator.BIAS(data)
  let rawData = [
    {name: 'BIAS6', color: lineColor[0], data: res[0]},
    {name: 'BIAS12', color: lineColor[1], data: res[1]},
    {name: 'BIAS24', color: lineColor[2], data: res[2]}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}

const createCCI = data => {
  const res = Indicator.CCI(data)
  let rawData = [
    {name: 'CCI', color: lineColor[0], data: res}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}

const createWR = data => {
  const res = Indicator.WR(data)
  let rawData = [
    {name: 'WR6', color: lineColor[0], data: res[0]},
    {name: 'WR10', color: lineColor[1], data: res[1]}
  ]
  return {
    series: createLines(rawData),
    rawData
  }
}

export default {
  createMACD,
  createKDJ,
  createRSI,
  createBOLL,
  createOBV,
  createBIAS,
  createCCI,
  createWR
}
